import { render, staticRenderFns } from "./ChooseVolunteersReadOnlyView.vue?vue&type=template&id=3ed46968&scoped=true&"
import script from "./ChooseVolunteersReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ChooseVolunteersReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ChooseVolunteersReadOnlyView.vue?vue&type=style&index=0&id=3ed46968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed46968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VForm,VLayout})
